'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = require('preact');

var _preactFela = require('preact-fela');

var _Core = require('../Core');

var _NavbarListLink = require('./NavbarListLink');

var _NavbarListLink2 = _interopRequireDefault(_NavbarListLink);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var rules = function rules(_ref) {
  var inScroll = _ref.inScroll;
  return {
    nav: {
      width: '100%',
      borderTop: '1px solid #e0e0e0',
      desktop: _extends({
        display: 'flex',
        alignItems: 'center',
        alignSelf: 'stretch',
        left: 0
      }, inScroll ? {
        width: 'auto',
        position: 'relative',
        top: 0,
        borderTop: 'none'
      } : {
        position: 'absolute',
        top: '100%',
        borderTopColor: 'rgba(255, 255, 255, 0.3)'
      })
    }
  };
};

var linksStyle = function linksStyle() {
  return {
    margin: '0 0 20px',
    position: 'relative',
    desktop: {
      flex: 1,
      margin: 0
    }
  };
};

var Links = (0, _preactFela.createComponent)(linksStyle);

var extend = {
  dropdownContent: {
    desktop: {
      left: '0',
      transform: 'none'
    }
  }
};

var NavbarList = function (_Component) {
  _inherits(NavbarList, _Component);

  function NavbarList() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, NavbarList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = NavbarList.__proto__ || Object.getPrototypeOf(NavbarList)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      open: {}
    }, _this.handleClickLink = function (event, menu) {
      _this.props.goMenu(event, menu);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NavbarList, [{
    key: 'handleToggle',
    value: function handleToggle(index) {
      this.setState(function (state) {
        var open = state.open;

        open[index] = !(open[index] || false);
        return _extends({}, state, { open: open });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          inScroll = _props.inScroll,
          mobile = _props.mobile,
          menus = _props.menus,
          config = _props.config,
          styles = _props.styles,
          _props$clicktype = _props.clicktype,
          clicktype = _props$clicktype === undefined ? 'menu-lateral' : _props$clicktype,
          _props$login = _props.login,
          login = _props$login === undefined ? {} : _props$login,
          _props$signUp = _props.signUp,
          signUp = _props$signUp === undefined ? {} : _props$signUp;

      var isLoginAndSignUpDisabled = login.disabledInNavbar && signUp.disabledInNavbar;

      if (menus.length === 0) {
        return null;
      }

      var showDivider = !mobile && inScroll && !isLoginAndSignUpDisabled;

      return (0, _preact.h)(
        'nav',
        { className: styles.nav },
        menus.map(function (menu, index) {
          if (menu.items) {
            if (_this2.state.open[index] === undefined) {
              _this2.state.open[index] = false;
            }
            return (0, _preact.h)(
              _Core.Dropdown,
              { styleExtend: extend, open: _this2.state.open[index], toggle: function toggle() {
                  return _this2.handleToggle(index);
                }, key: 'dl' + (mobile && '-m') + (inScroll && '-s') + '-' + index, label: menu.label, inside: mobile, inScroll: inScroll, mobile: mobile, config: config, gtm: (0, _utils.getAttrsGtm)(menu.label, { clicktype: clicktype }) },
              (0, _preact.h)(
                Links,
                null,
                menu.items.map(function (item) {
                  return (0, _preact.h)(_NavbarListLink2.default, { mobile: mobile, menu: item, isSubmenu: true, config: config, handleClick: _this2.handleClickLink, clicktype: 'submenu' });
                })
              )
            );
          }

          return (0, _preact.h)(_NavbarListLink2.default, { mobile: mobile, menu: menu, config: config, handleClick: _this2.handleClickLink, clicktype: clicktype });
        }),
        showDivider && (0, _preact.h)(_Core.Dividir, null)
      );
    }
  }]);

  return NavbarList;
}(_preact.Component);

exports.default = (0, _preactFela.connect)(rules)(NavbarList);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Navbar/NavbarList.js
// module id = 54
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38